import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ProductDashboardLastReceivedModel } from "src/app/core/models/product-model/product-dashboard-model/product-dashboard-lastreceived.model";
import { PRODUCT_DASHBOARD_LASTRECEIVED_DEMO } from "./product-dashboard-lastreceived-demo-data";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-lastreceived.component.html',
    selector: 'op-product-dashboard-lastreceived'
})
export class ProductDashboardLastReceivedComponent implements AfterViewInit {
    public lastReceivedInfo: ProductDashboardLastReceivedModel[];
    
    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.lastReceivedInfo = PRODUCT_DASHBOARD_LASTRECEIVED_DEMO;
            this.changeDetection.detectChanges();
        }, 500);
    }
}